import React, { useEffect, useState } from 'react';
import { ShieldCheck, Clock, Check, X, Loader2 } from 'lucide-react';
import { api } from '../context/AuthContext';

export const FreigabenCard = () => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState('');
  const load = () => api.get('/register/meine-freigaben').then((r) => setData(r.data)).catch(() => setData(null));
  useEffect(() => { load(); }, []);

  const act = async (n, aktion) => {
    if (aktion === 'widerrufen' && !window.confirm(`Zugriff für ${n.email} wirklich widerrufen?`)) return;
    setBusy(n.id);
    try { await api.post(`/register/meine-freigaben/${n.id}`, { aktion }); await load(); } finally { setBusy(''); }
  };

  if (!data || (!data.verwaltet.length && !data.zugriffe.length)) return null;
  return (
    <section className="pt-10" data-testid="dashboard-freigaben">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <h2 className="font-serif text-2xl text-[#1B3A5C] mb-4">Zugriffsfreigaben</h2>
        <div className="bg-white border border-gray-200 divide-y divide-gray-100">
          {data.verwaltet.map((n) => (
            <div key={n.id} className="flex flex-wrap items-center gap-3 px-5 py-3 text-sm" data-testid={`freigabe-${n.id}`}>
              {n.status === 'aktiv' ? <ShieldCheck className="w-4 h-4 text-emerald-600" /> : <Clock className="w-4 h-4 text-amber-600" />}
              <div className="flex-1 min-w-[220px]">
                <p className="text-[#1B3A5C]"><strong>{n.name || n.email}</strong> <span className="text-[#7a8a99] text-xs">({n.email})</span></p>
                <p className="text-xs text-[#34536b]">{n.status === 'aktiv' ? 'Hat Zugriff auf' : 'Möchte Zugriff auf'}: {n.akten_text} · angefragt von {n.angefragt_von}</p>
              </div>
              {busy === n.id ? <Loader2 className="w-4 h-4 animate-spin text-[#7a8a99]" /> : n.status === 'angefragt' ? (
                <div className="flex gap-2">
                  <button type="button" onClick={() => act(n, 'ablehnen')} data-testid={`freigabe-ablehnen-${n.id}`} className="inline-flex items-center gap-1 px-3 py-1.5 text-[11px] tracking-wider border border-gray-300 text-[#34536b] hover:border-rose-400 hover:text-rose-700"><X className="w-3 h-3" /> ABLEHNEN</button>
                  <button type="button" onClick={() => act(n, 'freigeben')} data-testid={`freigabe-freigeben-${n.id}`} className="inline-flex items-center gap-1 px-3 py-1.5 text-[11px] tracking-wider bg-[#1B3A5C] text-white hover:bg-[#b8893d]"><Check className="w-3 h-3" /> FREIGEBEN</button>
                </div>
              ) : (
                <button type="button" onClick={() => act(n, 'widerrufen')} data-testid={`freigabe-widerrufen-${n.id}`} className="px-3 py-1.5 text-[11px] tracking-wider border border-gray-300 text-[#34536b] hover:border-rose-400 hover:text-rose-700">ZUGRIFF WIDERRUFEN</button>
              )}
            </div>
          ))}
          {data.zugriffe.map((n) => (
            <div key={n.id} className="flex items-center gap-3 px-5 py-3 text-sm" data-testid={`zugriff-${n.id}`}>
              <ShieldCheck className="w-4 h-4 text-[#b8893d]" />
              <p className="text-[#1B3A5C]">Sie haben Zugriff auf das Mandat <strong>{n.mandant_name || `M-${n.mandanten_nr}`}</strong> <span className="text-xs text-[#34536b]">({n.akten_text})</span></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FreigabenCard;
